import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'shell-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class FooterComponent{
    //Variables
    currentDate : Date = new Date();
}
